import { useState } from 'react';
import { ReadLotacaoDto } from '@/api.types';
import { DataAmigavel } from '@/shared/utils/datas';
import { TipoLotacaoEstagioList, TipoLotacaoList } from '@/shared/constants/enumlist';
import AdicionarEditarLotacaoModal, {
  TipoPessoaLotacaoModal,
} from '../../modals/AdicionarEditarLotacaoModal';
import { BotaoAcaoPerfil } from '../../components/BotaoAcaoPerfil';

const TIPO_LOTACAO_LIST = TipoLotacaoList.concat(TipoLotacaoEstagioList);

type LotacoesPerfilTableProps = {
  lotacoes: ReadLotacaoDto[];
  emptyMessage: string;
  /** Inclui tipos de lotação de estágio (útil no perfil estagiário). */
  incluirTiposEstagio?: boolean;
  tipoPessoa: TipoPessoaLotacaoModal;
  pessoaLotadaId: number | null | undefined;
  onRecarregar: () => void;
};

export function LotacoesPerfilTable({
  lotacoes,
  emptyMessage,
  incluirTiposEstagio = false,
  tipoPessoa,
  pessoaLotadaId,
  onRecarregar,
}: LotacoesPerfilTableProps) {
  const tipos = incluirTiposEstagio ? TIPO_LOTACAO_LIST : TipoLotacaoList;
  const podeGerenciar = Boolean(pessoaLotadaId && pessoaLotadaId > 0);
  const [modalShow, setModalShow] = useState(false);
  const [lotacaoIdEdicao, setLotacaoIdEdicao] = useState<number | null>(null);

  const abrirNova = () => {
    setLotacaoIdEdicao(null);
    setModalShow(true);
  };

  const abrirEditar = (id: number) => {
    setLotacaoIdEdicao(id);
    setModalShow(true);
  };

  return (
    <>
      <div className="d-flex justify-content-end mb-2">
        <BotaoAcaoPerfil
          tipo="adicionar"
          disabled={!podeGerenciar}
          onClick={abrirNova}
          title={
            podeGerenciar
              ? undefined
              : 'Salve a pessoa com o perfil correspondente antes de cadastrar lotações.'
          }
        >
          Adicionar lotação
        </BotaoAcaoPerfil>
      </div>

      {lotacoes.length === 0 ? (
        <p className="text-muted small mb-0 py-1">{emptyMessage}</p>
      ) : (
        <table className="table table-sm table-bordered table-hover table-striped mb-0">
          <thead>
            <tr>
              <th>Tipo</th>
              <th className="text-center">Início</th>
              <th className="text-center">Término</th>
              <th>Local</th>
              <th className="text-end">Ações</th>
            </tr>
          </thead>
          <tbody>
            {lotacoes.map((lotacao, index) => {
              const local =
                lotacao.defensoria?.nome || lotacao.nucleo?.nome || lotacao.setor?.nome || '-';
              return (
                <tr key={lotacao.id ?? index}>
                  <td>{tipos.find((a) => a.value === lotacao.tipo)?.name ?? '-'}</td>
                  <td className="text-center">
                    {lotacao.data_inicial ? DataAmigavel(lotacao.data_inicial) : '-'}
                  </td>
                  <td className="text-center">
                    {lotacao.data_final ? DataAmigavel(lotacao.data_final) : '-'}
                  </td>
                  <td>{local}</td>
                  <td className="text-end">
                    {lotacao.id ? (
                      <BotaoAcaoPerfil tipo="editar" onClick={() => abrirEditar(lotacao.id)} />
                    ) : (
                      '-'
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}

      {modalShow && podeGerenciar && (
        <AdicionarEditarLotacaoModal
          show={modalShow}
          handleHide={() => setModalShow(false)}
          tipoPessoa={tipoPessoa}
          pessoaLotadaId={pessoaLotadaId!}
          lotacaoId={lotacaoIdEdicao}
          onSalvo={onRecarregar}
        />
      )}
    </>
  );
}
